import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../Baseurl";
import { useParams } from "react-router-dom";

export default function SharedAccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
//   const token = searchParams.get("token");  
  const {token} = useParams();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      Swal.fire({
        icon: "error",
        title: "Invalid access",
        text: "Token is missing in the URL",
      });
    }
  }, [token]);





const handleSubmit = async (e) => {
  e.preventDefault();
  if (!email) {
    Swal.fire({ icon: "error", title: "Email required", text: "Please enter your email" });
    return;
  }
  if (!token) return;

  setLoading(true);

  const payload = { email, token };
  console.log("📤 Sending payload to verifyEmailToken:", payload);

  try {
    const response = await axios.post(`${baseurl}verifyEmailToken`, payload);
    console.log("✅ Response from server:", response.data);

    if (response.data.success) {
      const { project_id, access_type, expires_at, title } = response.data; // ✅ destructure

      // Store session info in localStorage
      localStorage.setItem("sharedAccessEmail", email);
      localStorage.setItem("sharedAccessToken", token);
      localStorage.setItem("project_id", project_id);
      localStorage.setItem("access_type", access_type);
      localStorage.setItem("titlenew", title);


      
      if (expires_at) {
        localStorage.setItem("expires_at", expires_at);
      }

      Swal.fire({
        icon: "success",
        title: "Access granted",
        showConfirmButton: false,
        timer: 1500,
      });

      navigate(`/board/${project_id}/${title}`);
    } else {
      Swal.fire({
        icon: "error",
        title: "Access denied",
        text: response.data.message || "Invalid email or token",
      });
    }
  } catch (err) {
    console.error("❌ Error verifying email token:", err);
    Swal.fire({
      icon: "error",
      title: "Server error",
      text: "Please try again later",
    });
  } finally {
    setLoading(false);
  }
};







  return (
    <div className="bg-light min-vh-100 d-flex justify-content-center align-items-center">
      <div className="card p-4" style={{ maxWidth: "400px", width: "100%" }}>
        <h3 className="text-center mb-3">Shared Project Access</h3>
        <p className="text-center text-muted mb-3">Enter your email to access the shared board</p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3 text-start">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input
              type="email"
              id="email"
              className="form-control"
              placeholder="Enter Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? "Checking..." : "Access Board"}
          </button>
        </form>
      </div>
    </div>
  );
}
